import { render, staticRenderFns } from "./CoverInpainting.vue?vue&type=template&id=11fe2095&"
import script from "./CoverInpainting.vue?vue&type=script&lang=js&"
export * from "./CoverInpainting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports